'use strict';
const Backbone = require('backbone');
const _ = require('underscore');
const StateType = require('../state-type');

module.exports = Backbone.Model.extend({
    defaults: {
        name: '',
        type: null  // state type [initial, final, normal, terminated]
    },

    toJSON: function() {
        let j = this.constructor.__super__.toJSON.call(this);
        j.type = this.getType().name;
        return j;
    },

    getName: function() {
        return this.get('name');
    },

    getType: function() {
        return this.get('type');
    },

    isInitial: function() {
        return this.getType() == StateType.types['initial'];
    },

    isFinal: function() {
        return this.getType() == StateType.types['final'];
    },

    isTerminated: function() {
        return this.getType() == StateType.types['terminated'];
    }
});



// WEBPACK FOOTER //
// ./process/domain/entity/action/state.js